import { ConfirmSalaryModal } from './ui';

export { ConfirmSalaryModal };
